module.exports = __webpack_public_path__ + "static/5-279e440a9c7666f7d4a1fc232d8e15cd.png";